import { store } from "../store/store";
import Full from "../layouts/Full";

const Wizard = () => import("../views/wizard/Wizard.vue");
const WizardCompanyProfile = () => import("../views/wizard/CompanyProfile.vue");

const ifAuthenticated = async (to, from, next) => {
  const isAuthenticated = await store.getters["auth/isAuthenticated"];

  if (isAuthenticated) {
    next();
    return;
  }
  next({ name: "session-login" });
};

const ifWizardCompleted = async () => {
  await store.dispatch("company/fetchCompanies");
  return await store.getters["company/isWizardCompleted"];
};

export default {
  path: "/wizard",
  component: Full,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "/wizard",
      component: Wizard,
      beforeEnter: ifAuthenticated,
      meta: {
        analyticsEventId: "/wizard",
        title: "message.common.yourVisibility",
        breadcrumb: null,
        requiresAuth: true
      },
      children: [
        {
          path: "/wizard",
          name: "wizard",
          component: WizardCompanyProfile,
          meta: {
            analyticsEventId: "/wizard",
            position: 1,
            requiresAuth: true
          }
        }
      ]
    }
  ]
};
